<!--<div class="container">
    <div class="row mt-3">
        <div class="col-6">
            <a class="navbar-brand" href="#">
                <img alt="Logo" src="assets/images/main-logo.svg"/>
            </a>
        </div>
        <div class="col-6 d-flex align-items-center justify-content-end">
            <div class="btn-group">
                <button type="button" class="btn language-selection dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    English
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item" type="button">English</button>
                    <button class="dropdown-item" type="button">Sinhala</button>
                    <button class="dropdown-item" type="button">Tamil</button>
                </div>
            </div>
        </div>
    </div>
</div>-->
<router-outlet></router-outlet>